module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("preferences.title")))]), _vm._v(" "), _c('div', {
    staticClass: "preferences-users"
  }, [_c('div', {
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.name")) + " :")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.currentUser.user.lastname
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.userName")) + " :")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.currentUser.user.firstname
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "preferences-select"
  }, [_c('div', {
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.language")) + " :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLang),
      expression: "selectedLang"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "extra-option",
    domProps: {
      "value": _vm.LAST_VALUE
    }
  }, [_vm._v(_vm._s(_vm.$t("preferences.option.language")))]), _vm._v(" "), _vm._l((_vm.getLangs), function(lang) {
    return _c('option', {
      key: lang.id,
      domProps: {
        "value": lang.id,
        "selected": _vm.selectedLang === lang.id
      }
    }, [_vm._v(" " + _vm._s(lang.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.brand")) + " :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBrandId),
      expression: "selectedBrandId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBrandId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.brandChanged]
    }
  }, [(_vm.brandsList.length > 1) ? _c('option', {
    staticClass: "extra-option",
    domProps: {
      "value": _vm.LAST_VALUE
    }
  }, [_vm._v(_vm._s(_vm.$t("preferences.option.brand")))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandsList), function(brand) {
    return _c('option', {
      key: brand.id,
      domProps: {
        "value": brand.id,
        "selected": _vm.selectedBrandId === brand.id
      }
    }, [_vm._v("\n                    " + _vm._s(brand.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aBrandIsSelected),
      expression: "aBrandIsSelected"
    }],
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.zoned")) + " :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedZoneId),
      expression: "selectedZoneId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedZoneId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "extra-option",
    domProps: {
      "value": -1
    }
  }, [_vm._v(_vm._s(_vm.$t("preferences.option.zoned")))]), _vm._v(" "), _vm._l((_vm.zoneList), function(zone) {
    return _c('option', {
      key: zone.id,
      domProps: {
        "value": zone.id,
        "selected": _vm.selectedZoneId === zone.id
      }
    }, [_vm._v(" " + _vm._s(zone.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aBrandIsSelected),
      expression: "aBrandIsSelected"
    }],
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.stands")) + " :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStandId),
      expression: "selectedStandId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedStandId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.standChanged]
    }
  }, [_c('option', {
    staticClass: "extra-option",
    domProps: {
      "value": _vm.LAST_VALUE
    }
  }, [_vm._v(_vm._s(_vm.$t("preferences.option.stands")))]), _vm._v(" "), _vm._l((_vm.standsList), function(stand) {
    return _c('option', {
      key: stand.id,
      domProps: {
        "value": stand.id,
        "selected": _vm.selectedStandId === stand.id
      }
    }, [_vm._v("\n                    " + _vm._s(stand.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aBrandIsSelected && _vm.aStandIsSelected),
      expression: "aBrandIsSelected && aStandIsSelected"
    }],
    staticClass: "ligne"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("preferences.label.campaign")) + " :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCampaignId),
      expression: "selectedCampaignId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCampaignId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "extra-option",
    domProps: {
      "value": _vm.LAST_VALUE
    }
  }, [_vm._v(_vm._s(_vm.$t("preferences.option.campaign")))]), _vm._v(" "), _vm._l((_vm.campaignsList), function(campaign) {
    return _c('option', {
      key: campaign.id,
      domProps: {
        "value": campaign.id,
        "selected": _vm.selectedCampaignId === campaign.id
      }
    }, [_vm._v("\n                    " + _vm._s(campaign.name) + "\n                ")])
  })], 2)])]), _vm._v(" "), _c('footer', [_c('ClientColorButton', {
    on: {
      "click": _vm.savePreferences
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.save))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6363d2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/preferences/Preferences.vue
// module id = 3350
// module chunks = 0